import { Amplify } from 'aws-amplify'
import awsmobile from './src/aws-exports';

// Configure Amplify with your project settings
Amplify.configure(awsmobile);
export const onClientEntry = () => {
    if (typeof window !== "undefined") {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        (function (w, d, s, u) {
            w.gbwawc = {
                url: u,
                options: {
                    waId: "+919902580128",
                    siteName: "Careait",
                    siteTag: "Usually reply in 4 minutes",
                    siteLogo: "https://files.gallabox.com/661e339e8ab440cd525ae3f3/8fd442e0-3df1-4606-95eb-58c77a991442-Frame19858586913.png",
                    widgetPosition: "RIGHT",
                    welcomeMessage: "Hello 👋 Welcome to Careait.",
                    brandColor: "#25D366",
                    messageText: " Please message your requirement. Looking for",
                    replyOptions: ['Home Nursing / Elder Care','Patient Care / Attendants','ICU Care at Home','Mother & Baby Care'],
                    version: "v1",
                    widgetPositionMarginX: 12,
                    widgetPositionMarginY: 12,
                },
            };
            var h = d.getElementsByTagName(s)[0],
                j = d.createElement(s);
            j.async = true;
            j.src = u + "/whatsapp-widget.min.js?_=" + "2026-04-07 12";
            h.parentNode.insertBefore(j, h);
        })(window, document, "script", "https://waw.gallabox.com");
      `;
      document.body.appendChild(script);
    }
};